import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RequisitoClienteCreationContent } from './components/RequisitoClienteCreationContent';

export default function RequisitoClienteCreation() {
    return (
        <>
            <MainContent
                component={<RequisitoClienteCreationContent />}
                titulo='Edición de Requisito de Clientes'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
